export enum ROUTE_NAMES {
  INTRO = 'Intro',
  HOME = 'Home',
  LOGIN = 'Login',
  PROFILE = 'Profile',
  PRODUCT = 'Product',
  FREIGHT = 'Freight',
  CARGO = 'Cargo',
  ACCESS = 'Access',
  GAS = 'Gas',
  GAS_TRANSIT = 'GasTransit',
  INTRADAY = 'Intraday'
}
